var map = {
	"./Favorites": [
		1132,
		9,
		0,
		121
	],
	"./Favorites.tsx": [
		1132,
		9,
		0,
		121
	],
	"./FavoritesDeferred": [
		367,
		9
	],
	"./FavoritesDeferred.tsx": [
		367,
		9
	],
	"./FavoritesPage": [
		366,
		9
	],
	"./FavoritesPage.dictionary": [
		340,
		3
	],
	"./FavoritesPage.dictionary.json": [
		340,
		3
	],
	"./FavoritesPage.explanation": [
		1133,
		9,
		122
	],
	"./FavoritesPage.explanation.ts": [
		1133,
		9,
		122
	],
	"./FavoritesPage.tsx": [
		366,
		9
	],
	"./actions": [
		100,
		9
	],
	"./actions/": [
		100,
		9
	],
	"./actions/index": [
		100,
		9
	],
	"./actions/index.ts": [
		100,
		9
	],
	"./components/Loader": [
		1018,
		9,
		54
	],
	"./components/Loader/": [
		1018,
		9,
		54
	],
	"./components/Loader/Loader": [
		968,
		9,
		187
	],
	"./components/Loader/Loader.dictionary": [
		922,
		3,
		188
	],
	"./components/Loader/Loader.dictionary.json": [
		922,
		3,
		188
	],
	"./components/Loader/Loader.explanation": [
		1134,
		9,
		189
	],
	"./components/Loader/Loader.explanation.ts": [
		1134,
		9,
		189
	],
	"./components/Loader/Loader.module.scss": [
		1029,
		9,
		308
	],
	"./components/Loader/Loader.tsx": [
		968,
		9,
		187
	],
	"./components/Loader/index": [
		1018,
		9,
		54
	],
	"./components/Loader/index.ts": [
		1018,
		9,
		54
	],
	"./components/NoData": [
		1019,
		9,
		0,
		56
	],
	"./components/NoData/": [
		1019,
		9,
		0,
		56
	],
	"./components/NoData/NoData": [
		969,
		9,
		0,
		191
	],
	"./components/NoData/NoData.dictionary": [
		925,
		3,
		192
	],
	"./components/NoData/NoData.dictionary.json": [
		925,
		3,
		192
	],
	"./components/NoData/NoData.explanation": [
		1135,
		9,
		193
	],
	"./components/NoData/NoData.explanation.ts": [
		1135,
		9,
		193
	],
	"./components/NoData/NoData.module.scss": [
		1030,
		9,
		310
	],
	"./components/NoData/NoData.tsx": [
		969,
		9,
		0,
		191
	],
	"./components/NoData/index": [
		1019,
		9,
		0,
		56
	],
	"./components/NoData/index.ts": [
		1019,
		9,
		0,
		56
	],
	"./components/NoDataSkeleton": [
		891,
		9,
		57
	],
	"./components/NoDataSkeleton/": [
		891,
		9,
		57
	],
	"./components/NoDataSkeleton/NoDataSkeleton": [
		871,
		9,
		194
	],
	"./components/NoDataSkeleton/NoDataSkeleton.module.scss": [
		923,
		9,
		311
	],
	"./components/NoDataSkeleton/NoDataSkeleton.tsx": [
		871,
		9,
		194
	],
	"./components/NoDataSkeleton/constants": [
		892,
		9,
		195
	],
	"./components/NoDataSkeleton/constants.ts": [
		892,
		9,
		195
	],
	"./components/NoDataSkeleton/index": [
		891,
		9,
		57
	],
	"./components/NoDataSkeleton/index.ts": [
		891,
		9,
		57
	],
	"./components/PopularMatches": [
		893,
		9,
		0,
		59
	],
	"./components/PopularMatches/": [
		893,
		9,
		0,
		59
	],
	"./components/PopularMatches/PopularMatches": [
		872,
		9,
		0,
		200
	],
	"./components/PopularMatches/PopularMatches.dictionary": [
		874,
		3,
		201
	],
	"./components/PopularMatches/PopularMatches.dictionary.json": [
		874,
		3,
		201
	],
	"./components/PopularMatches/PopularMatches.explanation": [
		1136,
		9,
		202
	],
	"./components/PopularMatches/PopularMatches.explanation.ts": [
		1136,
		9,
		202
	],
	"./components/PopularMatches/PopularMatches.module.scss": [
		924,
		9,
		313
	],
	"./components/PopularMatches/PopularMatches.tsx": [
		872,
		9,
		0,
		200
	],
	"./components/PopularMatches/index": [
		893,
		9,
		0,
		59
	],
	"./components/PopularMatches/index.ts": [
		893,
		9,
		0,
		59
	],
	"./components/SportGrid": [
		858,
		9,
		67
	],
	"./components/SportGrid/": [
		858,
		9,
		67
	],
	"./components/SportGrid/SportGrid": [
		842,
		9,
		214
	],
	"./components/SportGrid/SportGrid.module.scss": [
		873,
		9,
		318
	],
	"./components/SportGrid/SportGrid.tsx": [
		842,
		9,
		214
	],
	"./components/SportGrid/index": [
		858,
		9,
		67
	],
	"./components/SportGrid/index.ts": [
		858,
		9,
		67
	],
	"./components/TournamentTable": [
		843,
		9,
		78
	],
	"./components/TournamentTable/": [
		843,
		9,
		78
	],
	"./components/TournamentTable/TournamentTable": [
		836,
		9,
		227
	],
	"./components/TournamentTable/TournamentTable.ts": [
		836,
		9,
		227
	],
	"./components/TournamentTable/index": [
		843,
		9,
		78
	],
	"./components/TournamentTable/index.ts": [
		843,
		9,
		78
	],
	"./reducer": [
		295,
		9
	],
	"./reducer/": [
		295,
		9
	],
	"./reducer/entities": [
		352,
		9
	],
	"./reducer/entities.ts": [
		352,
		9
	],
	"./reducer/index": [
		295,
		9
	],
	"./reducer/index.js": [
		295,
		9
	],
	"./reducer/presentation": [
		353,
		9
	],
	"./reducer/presentation.ts": [
		353,
		9
	],
	"./selectors/gridEntities": [
		129,
		9
	],
	"./selectors/gridEntities.ts": [
		129,
		9
	],
	"./selectors/gridPresentation": [
		1079,
		9,
		0,
		257
	],
	"./selectors/gridPresentation.ts": [
		1079,
		9,
		0,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1268;
module.exports = webpackAsyncContext;